/**
 * Enregistrement du Service Worker YouElec BOS (PWA Vague 1).
 *
 * - Enregistre /sw.js uniquement en production (npm run build) pour éviter
 *   les conflits avec le hot-reload de CRACO.
 * - Possibilité de forcer en dev via window.__YEBOS_FORCE_SW = true.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  const isProd = process.env.NODE_ENV === "production";
  const forced = typeof window !== "undefined" && window.__YEBOS_FORCE_SW;
  if (!isProd && !forced) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((reg) => {
        // Hook pour invalider l'ancien SW lors d'un nouveau deploy
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (
              nw.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // Nouvelle version dispo — on prend le contrôle au prochain reload.
              try {
                nw.postMessage("SKIP_WAITING");
              } catch (_e) {
                /* no-op */
              }
            }
          });
        });
      })
      .catch((err) => {
        // Log silencieux — PWA n'est pas critique au démarrage
        if (typeof console !== "undefined") {
          console.warn("[YouElec PWA] SW registration failed:", err);
        }
      });
  });
}
